const languageInfo =  {
    "1": {
        "id": "1",
        "en_name": "English",
        "ch_name": "英文",
        "short_name": "en"
    },
    "2": {
        "id": "2",
        "en_name": "SimpChinese",
        "ch_name": "简体中文",
        "short_name": "zh-CN"
    },
    "3": {
        "id": "3",
        "en_name": "TradChinese",
        "ch_name": "繁体中文",
        "short_name": "zh-TW"
    },
    "4": {
        "id": "4",
        "en_name": "German",
        "ch_name": "德文",
        "short_name": "de"
    },
    "5": {
        "id": "5",
        "en_name": "French",
        "ch_name": "法文",
        "short_name": "fr"
    },
    "6": {
        "id": "6",
        "en_name": "Portuguese",
        "ch_name": "葡萄牙语",
        "short_name": "pt"
    },
    "7": {
        "id": "7",
        "en_name": "Russian",
        "ch_name": "俄罗斯语",
        "short_name": "ru"
    },
    "8": {
        "id": "8",
        "en_name": "Italian",
        "ch_name": "意大利语",
        "short_name": "it"
    },
    "9": {
        "id": "9",
        "en_name": "Turkish",
        "ch_name": "土耳其语",
        "short_name": "tr"
    },
    "10": {
        "id": "10",
        "en_name": "Polish",
        "ch_name": "波兰语",
        "short_name": "pl"
    },
    "11": {
        "id": "11",
        "en_name": "Arabic",
        "ch_name": "阿拉伯语",
        "short_name": "ar"
    },
    "12": {
        "id": "12",
        "en_name": "Farsi",
        "ch_name": "波斯语",
        "short_name": "fa"
    },
    "13": {
        "id": "13",
        "en_name": "Czech",
        "ch_name": "捷克语",
        "short_name": "cs"
    },
    "14": {
        "id": "14",
        "en_name": "Danish",
        "ch_name": "丹麦语",
        "short_name": "da"
    },
    "15": {
        "id": "15",
        "en_name": "Finnish",
        "ch_name": "芬兰语",
        "short_name": "fi"
    },
    "16": {
        "id": "16",
        "en_name": "Greek",
        "ch_name": "希腊语",
        "short_name": "el"
    },
    "17": {
        "id": "17",
        "en_name": "Nederlands",
        "ch_name": "荷兰语",
        "short_name": "nl"
    },
    "18": {
        "id": "18",
        "en_name": "Norwegian",
        "ch_name": "挪威语",
        "short_name": "nb"
    },
    "19": {
        "id": "19",
        "en_name": "Spanish",
        "ch_name": "西班牙语",
        "short_name": "es"
    },
    "20": {
        "id": "20",
        "en_name": "Swedish",
        "ch_name": "瑞典语",
        "short_name": "sv"
    },
    "21": {
        "id": "21",
        "en_name": "Hindi",
        "ch_name": "印地语",
        "short_name": "hi"
    },
    "22": {
        "id": "22",
        "en_name": "Japanese",
        "ch_name": "日语",
        "short_name": "ja"
    },
    "23": {
        "id": "23",
        "en_name": "Korean",
        "ch_name": "韩语",
        "short_name": "ko"
    },
    "24": {
        "id": "24",
        "en_name": "Thai",
        "ch_name": "泰语",
        "short_name": "th"
    },
    "25": {
        "id": "25",
        "en_name": "Vietnamese",
        "ch_name": "越南语",
        "short_name": "vi"
    },
    "26": {
        "id": "26",
        "en_name": "Hebrew",
        "ch_name": "希伯来语",
        "short_name": "he"
    },
    "27": {
        "id": "27",
        "en_name": "Romanian",
        "ch_name": "罗马尼亚语",
        "short_name": "ro"
    },
    "28": {
        "id": "28",
        "en_name": "Hungarian",
        "ch_name": "匈牙利语",
        "short_name": "hu"
    },
    "29": {
        "id": "29",
        "en_name": "Indonesian",
        "ch_name": "印度尼西亚语",
        "short_name": "id"
    },
    "30": {
        "id": "30",
        "en_name": "Ukrainian",
        "ch_name": "乌克兰语",
        "short_name": "uk"
    },
    "31": {
        "id": "31",
        "en_name": "Malay",
        "ch_name": "马来语",
        "short_name": "ms"
    },
    "32": {
        "id": "32",
        "en_name": "Filipino",
        "ch_name": "菲律宾语",
        "short_name": "fil"
    },
    "33": {
        "id": "33",
        "en_name": "Lithuanian",
        "ch_name": "立陶宛语",
        "short_name": "lt"
    },
    "34": {
        "id": "34",
        "en_name": "Cambodian",
        "ch_name": "柬埔寨语",
        "short_name": "km"
    },
    "35": {
        "id": "35",
        "en_name": "Bengali",
        "ch_name": "孟加拉语",
        "short_name": "bn"
    },
    "36": {
        "id": "36",
        "en_name": "Afrikaans",
        "ch_name": "南非语",
        "short_name": "af"
    },
    "37": {
        "id": "37",
        "en_name": "Icelandic",
        "ch_name": "冰岛语",
        "short_name": "is"
    },
    "38": {
        "id": "38",
        "en_name": "Belarusian",
        "ch_name": "白俄罗斯语",
        "short_name": "be"
    }
}
export {languageInfo}